export const getDateFromDateString = (dateString) => {
  if (dateString) {
    const date = new Date(dateString);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }
  return "";
};
